ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}

ProductReviews.Views.AddReview = require './product_reviews_add_review'
ProductReviews.Views.Histogram = require './product_reviews_histogram'
ProductReviews.Views.ReviewList = require './product_reviews_review_list'
ProductReviews.Views.UserReview = require './product_reviews_user_review'
ProductReviews.Model = require '../models/product_review'

ProductReviews.Views.Main = Backbone.View.extend
  el: '#product-reviews'
  body: 'body'
  touch:
    main: '.t-main'
    productRatings: '#product-ratings'
    productReviewsPane: '#product-reviews-pane'
    addReviewPane: '#product-reviews-add-pane'
    addReviewButton: '#product-reviews-add-review'

  events:
    'mouseover #user-rating.allow-submission .review-star': 'hoverStar'
    'click #user-rating.allow-submission .review-star': 'clickStar'
    'mouseout #user-rating': 'clearHoverStar'
    'keyup #product-reviews-form-extension textarea': 'updateMinimumLengthNotification'
    'click #product-reviews-form-extension button': 'submitReview'
    'click #product-reviews-form-extension a': 'resetForm'

    'click .review-vote button.allow-submission': 'voteReview'
    'click #review-delete.allow-submission': 'deleteReview'
    'click .review-share': 'showShareTooltip'

    'click #product-reviews-pagination-button': 'showMoreReviews'
    'change #product-reviews-sort-filter select': 'resortReviews'

    'click .t-back-link': 'hideTouchReviewsPane'
    'click #product-reviews-add-review': 'addNewReview'

  initialize: ->
    @$el ?= $(@el)
    _.extend this, @options

    return @initializeTouchReviewsPane() if @isTouch

    @listenTo @model, 'change:rating', @updateStars
    @$el.find('textarea[placeholder]').PlaceholderField()

    @initializeTooltip()

    @$userRating = @$el.find '#user-rating'
    @$userStars = @$el.find '#user-rating .review-star'
    @$userReviewNotification = @$el.find '#user-review-notification'
    @$reviewFormExtension = @$el.find '#product-reviews-form-extension'
    @$reviewLengthNotification = @$el.find '#product-reviews-review-length-notification'
    @$reviewText = @$el.find '#product-reviews-form-extension textarea'
    @$reviewSubmit = @$el.find '#product-reviews-form-extension button'
    @$reviewCancel = @$el.find '#product-reviews-form-extension a'

    @$sortNotification = @$el.find '#product-reviews-sort-notification'
    @$paginationNotification = @$el.find '#product-reviews-pagination-notification'
    @$paginationLoader = @$el.find '#product-reviews-pagination-loader'
    @$paginationButton = @$el.find '#product-reviews-pagination'
    @$reviewFilter = @$el.find '#product-reviews-sort-filter select'
    @$reviewList = @$el.find '#product-reviews-list'

    @$loginRequiredTooltip = $('#product-reviews-login-required-tooltip')
    @$shareTooltip = $('#product-reviews-share-tooltip')

    @countdownOpen = '<span id="review-character-countdown">'
    @countdownClose = '</span>'

  initializeTooltip: ->
    @$quickViewTooltipTrigger = $('#product-reviews-quick-view.tooltip-trigger')
    @$formRatingTooltipTrigger = $('#product-reviews-form-rating.tooltip-trigger')
    @$quickViewTooltip = $('#product-reviews-quick-view-tooltip')

    @$quickViewTooltipTrigger.mouseover (e) => @$quickViewTooltip.attr('data-trigger','product-reviews-quick-view')
    @$formRatingTooltipTrigger.mouseover (e) => @$quickViewTooltip.attr('data-trigger','product-reviews-form-rating')

  initializeTouchReviewsPane: ->
    @$body = $(@body)
    @$el = $(@touch.productReviewsPane)
    @$mainTouchPane = $(@touch.main)
    @$productRatings = $(@touch.productRatings)
    @$addReviewButton = $(@touch.addReviewButton)

    (new ProductReviews.Views.Histogram {@product}).render()
    (new ProductReviews.Views.ReviewList {@collection}).render()

    if @userReview
      @$addReviewButton.hide()
      @renderUserReview()
    else
      @renderAddReviewPane()

    if @displayOptions.paginationEnabled
      @listenTo @collection, 'sync', @paginationListener

    @$mainTouchPane.hide()
    @$el.show()
    @$body.animate scrollTop: 0, 'slow'

  render: (reviewList) ->
    @resetNotifications()
    reviewList.render()
    @reloadBindings()
    @updatePagination()
    unless @isTouch
      @$paginationLoader.hide()
      @$reviewList.show()

  renderUserReview: ->
    @userReviewModel = new ProductReviews.Model @userReview, @collection.options
    @userReviewModel.view = this
    (new ProductReviews.Views.UserReview {model: @userReviewModel}).render()

  renderAddReviewPane: ->
    return unless @displayOptions.addReviewEnabled
    @$addReviewPane = $(@touch.addReviewPane)
    addReviewModel = new ProductReviews.Model @collection.options, @collection.options
    addReviewView = new ProductReviews.Views.AddReview {addReviewModel, productReviewsView: this}
    addReviewModel.view = addReviewView

  addNewReview: ->
    return @httpsRedirect() if @isTouch and not @reviewable

    return if @$addReviewButton.hasClass 'review-submitted'
    @$el.hide()
    @$addReviewPane.show()

  paginationListener: ->
    Touch.Scrolling.detectBottom =>
      @showMoreReviews()

  resetNotifications: ->
    @$el.find(".review-notification").hide()

  httpsRedirect: (element) ->
    if @isTouch
      redirectUrl = @displayOptions.loginRequired?.redirectUrl
      window.location.href = redirectUrl if redirectUrl
    else
      window.location.assign "#{@dealUrl}#{element}"

  hideTooltips: ->
    @$loginRequiredTooltip.find('.tooltip-close').click()
    @$shareTooltip.find('.tooltip-close').click()

  showShareTooltip: (e) ->
    $reviewCard = $(e.currentTarget).closest(".review-card")

    if $reviewCard.length
      username = $reviewCard.find('.review-display-name').data('display-name')
      text = $reviewCard.find('.review-text').text()

      emailSubject =  encodeURIComponent(I18n.t 'js.modules.product_reviews.share_review.email_subject', {dealTitle: @dealTitle, username: username})
      emailBody = encodeURIComponent("#{@dealTitle}\n#{@dealUrl}\n\n\"#{text}\"\n- #{username}")
      hrefText = "mailto:?subject=#{emailSubject}&body=#{emailBody}&utm_campaign=UserReferral&utm_medium=email&utm_source=uu"

      @$shareTooltip.find('.icon-email').attr('href', hrefText)

  updateMinimumLengthNotification: ->
    reviewLength = @$reviewText.val().length
    remainder = @minimumReviewLength - reviewLength
    if remainder <= 0
      @$reviewLengthNotification.removeClass('warning').addClass('success')
      remainder = 0
    else
      @$reviewLengthNotification.removeClass('success').addClass('warning')
    if @maximumReviewLength - reviewLength < 0
      text = @$reviewText.val().substring(0, @maximumReviewLength)
      @$reviewText.val(text)
    @$reviewLengthNotification.html I18n.p remainder, 'js.modules.product_reviews.review_form.review_length', {minimumLength:@minimumReviewLength, countdownOpen:@countdownOpen, countdownClose:@countdownClose}

  showMoreReviews: ->
    @resetNotifications()
    if @isTouch
      @collection.nextPage()
    else
      @hideTooltips()
      @$paginationLoader.show()
      @collection.nextPage @$reviewFilter.val()

  resortReviews: ->
    @resetNotifications()
    @hideTooltips()
    @$reviewList.hide()
    @$paginationLoader.show()
    @collection.resortReviews @$reviewFilter.val()

  updatePagination: ->
    reviewsLength = @collection.length
    displayedReviewCount =
      formatted: I18n.toNumber reviewsLength
      value: reviewsLength

    if @isTouch
      if displayedReviewCount.value >= @totalReviewCount
        @stopListening @collection, 'sync', @paginationListener
    else
      @$el.find('#product-reviews-display-count span').text I18n.t 'js.modules.product_reviews.pagination.showing_count', {formattedDisplayedReviewCount: displayedReviewCount.formatted, formattedReviewCount: @reviewCount.formatted}
      if displayedReviewCount.value < @reviewCount.value then @$paginationButton.show() else @$paginationButton.hide()

  reloadBindings: ->
    GIG.Tooltip.reloadBindings(@$el) if $('#product-reviews-login-required-tooltip').length or $('#product-reviews-pending-tooltip').length or $('#product-reviews-share-tooltip').length
    IframeLogin.reloadBindings(@$el) if $('#login-modal').length

  findReview: (placement, id) ->
    if placement is 'helpful'
      @helpfulCollection.get id
    else
      @collection.get id

  showPaginationError: (action) ->
    return @stopListening @collection, 'sync', @paginationListener if @isTouch

    @$paginationLoader.hide()
    @$reviewList.show()
    @$reviewFilter.val @collection.sortBy
    if action is 'nextPage' then @$paginationNotification.show() else @$sortNotification.show()

  updateRatingDescriptionText: (star) ->
    unless @$ratingDescription
      $('#product-reviews-product-info').append $("<span id='rating-description'/>")
      @$ratingDescription = @$el.find '#rating-description'
    @$ratingDescription.text if star then "\"#{I18n.t "js.modules.product_reviews.review_form.rating_description.rating_#{star}"}\"" else ''

  hoverStar: (e) ->
    @$userStars.removeClass('selected-star')
    rating = $(e.currentTarget).data('star-rating')
    for x in [1..5]
      star = $("#review-star-#{x}")
      if x <= rating then star.addClass('hovered-star') else star.removeClass('hovered-star').addClass('empty-star')
    @updateRatingDescriptionText rating

  clearHoverStar: ->
    @$userStars.removeClass('hovered-star')
    rating =  @model.get('rating')
    for x in [1..5]
      star = $("#review-star-#{x}")
      if x <= rating then star.addClass('selected-star') else star.addClass('empty-star')
    @updateRatingDescriptionText rating

  clickStar: (e) ->
    return @httpsRedirect('#product-reviews') unless @reviewable
    @model.set 'rating', $(e.currentTarget).data('star-rating')
    @$reviewFormExtension.slideDown('slow')

  updateStars: ->
    rating = @model.get('rating')
    for x in [1..5]
      star = $("#review-star-#{x}")
      if x <= rating then star.removeClass('empty-star').addClass('selected-star') else star.addClass('empty-star').removeClass('selected-star')
    @updateRatingDescriptionText rating

  submitReview: ->
    @resetNotifications()
    @model.set 'text', $('#product-reviews-form-extension textarea').val()
    @$reviewSubmit
      .attr('disabled','disabled')
      .addClass('btn-secondary')
    @$reviewCancel.hide()
    @model.review()

  showReviewSuccess: (userReview) ->
    @resetForm()
    userReview.render()
    @$reviewSubmit.hide()
    @$ratingDescription.hide()
    @$userReviewNotification
      .removeClass('error')
      .addClass('success')
      .text(I18n.t 'js.modules.product_reviews.create_review.success')
      .show()
    @reloadBindings()
    @disableStarButton()

  showReviewError: ->
    @$userReviewNotification
      .removeClass('success')
      .addClass('error')
      .text(I18n.t 'js.modules.product_reviews.create_review.error')
      .show()
    @enableSubmit()
    @$reviewCancel.show()

  enableSubmit: ->
    @$reviewSubmit
      .removeAttr('disabled')
      .removeClass('btn-secondary')
      .html('Submit')

  disableStarButton: ->
    @$userRating.removeClass('allow-submission').hide()
    @$userStars.removeClass('hovered-star')

  resetForm: ->
    @model.set 'rating', 0
    @$reviewFormExtension.slideUp('slow')
    @enableSubmit()
    @$reviewCancel.show()

  voteReview: (e) ->
    return @httpsRedirect() if @isTouch and not @reviewable

    $target = $(e.currentTarget)
    unless @reviewable
      anchor = if $target.data('review-placement') is 'helpful'
        '#product-reviews-helpful-reviews'
      else
        '#product-reviews-list'
      return @httpsRedirect(anchor)

    review = @findReview $target.data('review-placement'), $target.data('review-id')

    $target.attr('disabled','disabled')
    @resetNotifications()

    review.view = this
    if $target.hasClass 'upvoted' then review.unvote() else review.upvote()

  showVoteSuccess: (model) ->
    reviewIds = model.get('reviewIds')
    helpfulUpvote = model.get('helpfulUpvote')
    voteButton = $("##{reviewIds.vote}")

    if helpfulUpvote.buttonClass is 'upvoted'
      voteButton.addClass('upvoted')
      successMessage = I18n.t 'js.modules.product_reviews.upvote_review.success'
    else
      voteButton.removeClass('upvoted')
      successMessage = I18n.t 'js.modules.product_reviews.unvote_review.success'

    voteButton.text(helpfulUpvote.buttonText).removeAttr('disabled')
    @$el.find("##{reviewIds.voteText}").text helpfulUpvote.text
    @$el.find("##{reviewIds.notification}")
      .removeClass('error')
      .addClass('success')
      .text(successMessage)
      .show()

  showVoteError: (model)->
    reviewIds = model.get('reviewIds')
    $("##{reviewIds.vote}").removeAttr('disabled')
    helpfulUpvote = model.get('helpfulUpvote')

    if helpfulUpvote.buttonClass is 'upvoted'
      errorMessage = I18n.t 'js.modules.product_reviews.unvote_review.error'
    else
      errorMessage = I18n.t 'js.modules.product_reviews.upvote_review.error'

    @$el.find("##{reviewIds.notification}")
      .removeClass('success')
      .addClass('error')
      .text(errorMessage)
      .show()

  deleteReview: (e) ->
    if @isTouch
      @$addReviewButton.hide()
      return @userReviewModel.delete()

    return @httpsRedirect('#product-reviews') unless @reviewable

    @resetNotifications()
    $("#user-review-notification-#{@model.id}").hide()
    @model.delete()

  showDeleteSuccess: (model) ->
    reviewIds = model.get('reviewIds')
    @$el.find('#review-delete').hide()
    @$el.find("##{reviewIds.notification}")
      .removeClass('error')
      .addClass('success')
      .text(I18n.t 'js.modules.product_reviews.delete_review.success')
      .show()

  showDeleteError: (model) ->
    reviewIds = model.get('reviewIds')
    @$el.find('#review-delete').hide()
    @$el.find("##{reviewIds.notification}")
      .removeClass('success')
      .addClass('error')
      .text(I18n.t 'js.modules.product_reviews.delete_review.error')
      .show()

  hideTouchReviewsPane: ->
    @$el.hide()
    @$mainTouchPane.show()
    @$body.animate scrollTop: @$productRatings.position().top, 'slow'


module.exports = ProductReviews.Views.Main
